import { Icon } from "semantic-ui-react";
import { IMenuBarProps } from "../interfaces/common/IMenuBarProps";

/**
 * Top menu bar of the general homepage.
 */
export const MenuBar = ({ username, instance, roles }: IMenuBarProps) => {

	return <>
		<div style={{ display: 'flex', background: '#fff' }}>
			<div style={{ flex: '1', padding: '10px' }}>
				<a href='/'>
					<img src='/vernova_green_logo.svg' alt='GE Vernova logo' style={{ width: '164px', paddingTop: '2px' }} />
				</a>
			</div>
			<div style={{ textAlign: 'right', overflow: 'hidden', whiteSpace: 'nowrap', fontSize: '16px', color: '#888', paddingTop: '20px' }}>
				<button onClick={() => instance.logoutRedirect()} style={{ marginLeft: '8px', marginRight: '18px', marginBottom: '12px', color: '#666', background: 'none', border: 'none', cursor: 'pointer' }}>
					<Icon name='log out'/>
				</button>
			</div>
		</div>
	</>;
}